<script setup lang="ts">
interface Props {
  data: {
    show: boolean
    action: string
    message: string
  }
}
const props = defineProps<Props>()
</script>

<template>
  <div
    class="snackbar"
    :class="{ show: props.data.show, [props.data.action]: true }"
  >
    {{ props.data.message }}
  </div>
</template>

<style lang="scss" scoped>
.snackbar {
  position: fixed;
  top: 88px;
  left: 50%;
  z-index: 9999;
  visibility: hidden;
  min-width: 250px;
  padding: 16px;
  margin-left: -125px;
  color: #fff;
  text-align: center;
  border: 1px white solid;
  border-radius: 5px;
  opacity: 0;
  transition: all 1s ease;

  &.success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }

  &.fail {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c;
  }
}

.snackbar.show {
  visibility: visible;
  opacity: 1;
}
</style>
